<tt-page>
    <tt-page-heading>{{ heading }}</tt-page-heading>
    <tt-cal-view [params]="params" (getLoaded)="heading = $event.webpage_heading"></tt-cal-view>
</tt-page>
